module.exports = __webpack_public_path__ + "static/media/fish.e6ca75c5.png";